import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import { getHelmet } from "../utilities";
import { GridWrapper, Banner, FromTopPage } from "../theme";
import VideoEmbed from "../components/video/VideoEmbed";
import thumbnail from "../assets/thumbnail-live.png";

const Container = styled(FromTopPage)`
  header {
    > div {
      padding: 50px 0 156px;
    }

    h1 {
      margin: auto;
      text-align: center;
      text-transform: none;
    }
  }
`;

const Content = styled(GridWrapper)`
  margin: -125px auto 10px;
`;

function Live() {
  const { pathname } = useLocation();

  return (
    <Container>
      <Helmet>
        {getHelmet(
          "Le Média 24/7",
          "Suivez Le Média en continu !",
          process.env.RAZZLE_HOSTNAME + pathname,
          thumbnail
        )}
      </Helmet>

      <Banner>
        <GridWrapper>
          <h1>Regardez-nous en&nbsp;continu !</h1>
        </GridWrapper>
      </Banner>

      <Content>
        <VideoEmbed
          video={{
            title: "Votre chaîne d’infos et de combats en continu 24h/24",
            attachments_by_keys: {
              video_youtube: {
                value: "https://youtube.com/watch?v=0aI87TDsc9c",
              },
            },
            thumb_video_page_url: thumbnail,
          }}
        />
      </Content>
    </Container>
  );
}

export default Live;
